import { render, staticRenderFns } from "./DashboardClarenceFull.vue?vue&type=template&id=89ce0cd2&scoped=true&"
import script from "./DashboardClarenceFull.vue?vue&type=script&lang=js&"
export * from "./DashboardClarenceFull.vue?vue&type=script&lang=js&"
import style0 from "./DashboardClarenceFull.vue?vue&type=style&index=0&id=89ce0cd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ce0cd2",
  null
  
)

export default component.exports